document.addEventListener('DOMContentLoaded', function() {
	function adjustWindowScroll(){
		const body = document.body;
		const browserZoomLevel = window.devicePixelRatio;

		// console.log(window.visualViewport.scale);

		if(browserZoomLevel > 1){
			body.style.overflowX = 'scroll';
		}
		else{
			body.style.overflowX = 'hidden';
		}
	}

	adjustWindowScroll();

	window.addEventListener('resize',()=>{
		adjustWindowScroll();
	})


})

